import { del, get, post, put } from "../../../core/api/client";
import { API_ENDPOINTS } from "../../../core/api/endpoints";

const encodeQueryValue = (value) => encodeURIComponent(value);

export const getPaymentMethods = async (
  clientId,
  params = {},
) => {
  const { limit = 20, offset = 0, status } = params;

  const queryParams = [
    `limit=${encodeQueryValue(limit)}`,
    `offset=${encodeQueryValue(offset)}`,
  ];

  if (status) {
    queryParams.push(`status=${encodeQueryValue(status)}`);
  }

  const queryString = queryParams.join("&");
  const endpoint = `${API_ENDPOINTS.PAYMENT_METHODS.LIST_BY_CLIENT(clientId)}?${queryString}`;
  return get(endpoint);
};

export const getPaymentMethodById = async (id) => {
    return get(API_ENDPOINTS.PAYMENT_METHODS.GET_BY_ID(id));
}

export const createPaymentMethod = async (
  payload,
  clientId,
) => {
  const body = {
    client_id: clientId,
    card_status: "active",
    is_default: true,
    ...payload,
  };
  return post(API_ENDPOINTS.PAYMENT_METHODS.CREATE, body);
};

export const updatePaymentMethod = async (id, payload) => {
  return put(API_ENDPOINTS.PAYMENT_METHODS.UPDATE(id), payload);
};

export const deletePaymentMethod = async (id) => {
  return del(API_ENDPOINTS.PAYMENT_METHODS.DELETE(id));
};
